import $ from 'jquery';
import './index.less';
import 'components/jquery';

import 'uikitcss';
import UIkit from 'uikit';
import Icons from './../../../node_modules/uikit/dist/js/uikit-icons.min.js';
export { iniciarAvisosIgpm } from './avisosIgpm';

UIkit.use(Icons);

export function getSideMenuFixed() {
    return localStorage.getItem('side-menu-fixed') === "true";
}

export function init() {
    setSideMenuClass();
}

export function toogleSideMenuFixed() {

    let fixed = !getSideMenuFixed();

    localStorage.setItem('side-menu-fixed', fixed.toString());

    setSideMenuClass();
}

export function setSideMenuClass() {
    if (getSideMenuFixed()) {
        $('body').removeClass('side-menu-auto');
        $('body').addClass('side-menu-fixed');
    } else {
        $('body').addClass('side-menu-auto');
        $('body').removeClass('side-menu-fixed');
    }
}
